import React from "react";
import { ExtendHTMLProps } from "../../../../types/ExtendProps";

export const ContainerPlaceholder = (
    props: ExtendHTMLProps<HTMLDivElement>
) => {

    return <div {...props}>{props.children}</div>

}